import { Action } from '@ngrx/store';
import { ConfType, Depot, Driver, DriverName, DriverNote, Machine, StatusType, Tour } from '@models/*';
import { ViewContainerRef } from '@angular/core';
import { SwapProposal } from '../../../interfaces/switch-machine';

export class LoadDriverData implements Action {
    readonly type = TourActionTypes.LOAD_DRIVER_DATA;

    constructor(public payload: { date: string, performPreload: boolean, refreshMsg: boolean }) {
    }
}

export class LoadDriverDataSuccess implements Action {
    readonly type = TourActionTypes.LOAD_DRIVER_DATA_SUCCESS;

    constructor(public payload: {
        depots: { [key: number]: Depot },
        driverId: number,
        driverNames: { [key: string]: DriverName },
        driverNotes: { [key: string]: DriverNote[] },
        drivers: { [key: string]: Driver },
        tours: Tour[],
        performPreload: boolean,
    }) {
    }
}

export class LoadDriverDataFail implements Action {
    readonly type = TourActionTypes.LOAD_DRIVER_DATA_FAIL;

    constructor(public payload: { error: any }) {
    }
}

export class LoadTourSingle implements Action {
    readonly type = TourActionTypes.LOAD_TOUR_SINGLE;

    constructor(public payload: number) {
    }
}

export class LoadTourSingleSuccess implements Action {
    readonly type = TourActionTypes.LOAD_TOUR_SINGLE_SUCCESS;

    constructor(public payload: Tour) {
    }
}

export class LoadTourSingleFail implements Action {
    readonly type = TourActionTypes.LOAD_TOUR_SINGLE_FAIL;

    constructor(public payload: { id: number, error: any }) {
    }
}

export class InitLoadAction implements Action {
    readonly type = TourActionTypes.INIT_LOAD_ACTION;

    constructor(
        public payload: {
            actionIds: number[],
            dialogInsertion: ViewContainerRef,
        }
    ) {
    }
}

/*
 * TODO: this can also replace InitLoadAction, InitUnloadAtDepot,
 *   and calling CompleteTourStopActions directly from component
 */
export class InitCompleteTourStopActions implements Action {
    readonly type = TourActionTypes.INIT_COMPLETE_TOUR_STOP_ACTIONS;

    constructor(
        public payload: {
            // actionIds?: number[],
            dialogInsertion: ViewContainerRef,
        }
    ) {
    }
}

export class CompleteTourStopActions implements Action {
    readonly type = TourActionTypes.COMPLETE_TOUR_STOP_ACTIONS;

    constructor(
        public payload: {
            updateData: {
                tourStopActionId: number,
                depotId: string | null,
                rasterLocation: string | null,
                vendorId: any | null,
                driverMessageForCounterParty?: string | null;
            }[],
            confirmationType: ConfType,
            timestamp: string,
            dialogInsertion: ViewContainerRef,
        }
    ) {
    }
}

export class UnloadMachinesAtRaster implements Action {
    readonly type = TourActionTypes.UNLOAD_MACHINES_AT_RASTER;

    constructor(
        public payload: { tourStopActionId: number, depotId: string | null, rasterLocation: string | null }[]
    ) {
    }
}

/** Adds the required TrackedActions (state) based on the given Tour Stop Action updates */
export class AddRequiredTrackedActions implements Action {
    readonly type = TourActionTypes.ADD_REQUIRED_TRACKED_ACTIONS;

    constructor(
        public payload: {
            tourStopActionId: number,
            status: StatusType,
            rasterLocation: string | null,
        }[]
    ) {
    }
}

export class AddRequiredTrackedActionsFail implements Action {
    readonly type = TourActionTypes.ADD_REQUIRED_TRACKED_ACTIONS_FAIL;

    constructor(public payload: { tourStopActionIds: number[], error: any }) {
    }
}

export class FuelRefill implements Action {
    readonly type = TourActionTypes.FUEL_REFILL;

    constructor(public payload: { tourStopActionId: number, transportId: number, amount: number }) {
    }
}

export class FuelRefillSuccess implements Action {
    readonly type = TourActionTypes.FUEL_REFILL_SUCCESS;

    constructor(public payload: { tourStopActionId: number, amount: number, time: string }) {
    }
}

export class FuelRefillFail implements Action {
    readonly type = TourActionTypes.FUEL_REFILL_FAIL;

    constructor(public payload: { tourStopActionId: number, error: any }) {
    }
}

export class SearchMachine implements Action {
    readonly type = TourActionTypes.SEARCH_MACHINE;

    constructor(public payload: string) {
    }
}

export class SearchMachineSuccess implements Action {
    readonly type = TourActionTypes.SEARCH_MACHINE_SUCCESS;

    constructor(public payload: Machine) {
    }
}

export class SearchMachineFail implements Action {
    readonly type = TourActionTypes.SEARCH_MACHINE_FAIL;

    constructor(public payload: { error: any }) {
    }
}

export class SwitchMachine implements Action {
    readonly type = TourActionTypes.SWITCH_MACHINE;

    constructor(
        public payload: {
            tourStopActionId: number,
            contractDetailId: string,
            newMachineInternalId: string,
            oldMachineInternalId: string,
            oldFleetNumber: string,
            newFleetNumber: string,
            noAutoSwap: boolean,
            dialogInsertion: ViewContainerRef,
        }
    ) {
    }
}

export class SwitchMachineSuccess implements Action {
    readonly type = TourActionTypes.SWITCH_MACHINE_SUCCESS;

    constructor(public payload: {
        oldMachineInternalId?: string,
        newFleetNumber?: string,
        contractDetailId?: string,
        swapProposal?: SwapProposal
    }) {
    }
}

export class SwitchMachineFail implements Action {
    readonly type = TourActionTypes.SWITCH_MACHINE_FAIL;

    constructor(public payload: { error: any, contractDetailId: string, }) {
    }
}

export class CancelSwitchMachine implements Action {
    readonly type = TourActionTypes.CANCEL_SWITCH_MACHINE;

    constructor() {
    }
}

export class CancelSwitchMachineUpdating implements Action {
    readonly type = TourActionTypes.CANCEL_SWITCH_MACHINE_UPDATING;

    constructor(public payload: {
        contractDetailId: string;
    }) {
    }
}

export class UpdateRasterLocation implements Action {
    readonly type = TourActionTypes.UPDATE_RASTER_LOCATION;

    constructor(public payload: { tourStopActionId: number, rasterLocation: string }) {
    }
}

export class ToggleToursFilter implements Action {
    readonly type = TourActionTypes.TOGGLE_TOURS_FILTER;
}

export class UpsertDriverNote implements Action {
    readonly type = TourActionTypes.UPSERT_DRIVER_NOTE;

    constructor(
        public payload: {
            tourStopActionId: number,
            driverNote: DriverNote,
        }
    ) {
    }
}

export class UpsertDriverNoteSuccess implements Action {
    readonly type = TourActionTypes.UPSERT_DRIVER_NOTE_SUCCESS;

    constructor(public payload: {
        driverNote: DriverNote,
    }) {
    }
}

export class UpsertDriverNoteFail implements Action {
    readonly type = TourActionTypes.UPSERT_DRIVER_NOTE_FAIL;

    constructor(public payload: { error: any, tourStopActionId: number }) {
    }
}

export class DeleteDriverNote implements Action {
    readonly type = TourActionTypes.DELETE_DRIVER_NOTE;

    constructor(
        public payload: {
            tourStopActionId: number,
            driverNote: DriverNote,
        }
    ) {
    }
}

export class DeleteDriverNoteSuccess implements Action {
    readonly type = TourActionTypes.DELETE_DRIVER_NOTE_SUCCESS;

    constructor(public payload: {
        tourStopActionId: number,
        driverNote: DriverNote,
    }) {
    }
}

export class DeleteDriverNoteFail implements Action {
    readonly type = TourActionTypes.DELETE_DRIVER_NOTE_FAIL;

    constructor(public payload: {
        error: any,
        tourStopActionId: number,
        driverNote: DriverNote,
    }) {
    }
}

export class UpsertDriverMessageForCounterParty implements Action {
    readonly type = TourActionTypes.UPSERT_DRIVER_MESSAGE_FOR_COUNTER_PARTY;

    constructor(
        public payload: {
            tourStopActionId: number,
            note: string,
        }
    ) {
    }
}

export class DeleteDriverMessageForCounterParty implements Action {
    readonly type = TourActionTypes.DELETE_DRIVER_MESSAGE_FOR_COUNTER_PARTY;

    constructor(
        public payload: {
            tourStopActionId: number,
        }
    ) {
    }
}

export enum TourActionTypes {
    LOAD_DRIVER_DATA = 'LOAD_DRIVER_DATA',
    LOAD_DRIVER_DATA_SUCCESS = 'LOAD_DRIVER_DATA_SUCCESS',
    LOAD_DRIVER_DATA_FAIL = 'LOAD_DRIVER_DATA_FAIL',
    LOAD_TOUR_SINGLE = 'LOAD_TOUR_SINGLE',
    LOAD_TOUR_SINGLE_SUCCESS = 'LOAD_TOUR_SINGLE_SUCCESS',
    LOAD_TOUR_SINGLE_FAIL = 'LOAD_TOUR_SINGLE_FAIL',
    COMPLETE_TOUR_STOP_ACTIONS = 'COMPLETE_TOUR_STOP_ACTIONS',
    UNLOAD_MACHINES_AT_RASTER = 'UNLOAD_MACHINES_AT_RASTERS',
    /** Adds the required TrackedActions (state) based on the given Tour Stop Action updates */
    ADD_REQUIRED_TRACKED_ACTIONS = 'ADD_REQUIRED_TRACKED_ACTIONS',
    ADD_REQUIRED_TRACKED_ACTIONS_FAIL = 'ADD_REQUIRED_TRACKED_ACTIONS_FAIL',
    FUEL_REFILL = 'FUEL_REFILL',
    FUEL_REFILL_SUCCESS = 'FUEL_REFILL_SUCCESS',
    FUEL_REFILL_FAIL = 'FUEL_REFILL_FAIL',
    SEARCH_MACHINE = 'SEARCH_MACHINE',
    SEARCH_MACHINE_SUCCESS = 'SEARCH_MACHINE_SUCCESS',
    SEARCH_MACHINE_FAIL = 'SEARCH_MACHINE_FAIL',
    SWITCH_MACHINE = 'SWITCH_MACHINE',
    SWITCH_MACHINE_SUCCESS = 'SWITCH_MACHINE_SUCCESS',
    SWITCH_MACHINE_FAIL = 'SWITCH_MACHINE_FAIL',
    CANCEL_SWITCH_MACHINE = 'CANCEL_SWITCH_MACHINE',
    CANCEL_SWITCH_MACHINE_UPDATING = 'CANCEL_SWITCH_MACHINE_UPDATING',
    UPDATE_RASTER_LOCATION = 'UPDATE_RASTER_LOCATION',
    TOGGLE_TOURS_FILTER = 'TOGGLE_TOURS_FILTER',
    UPSERT_DRIVER_NOTE = 'UPSERT_DRIVER_NOTE',
    UPSERT_DRIVER_NOTE_FAIL = 'UPSERT_DRIVER_NOTE_FAIL',
    UPSERT_DRIVER_NOTE_SUCCESS = 'UPSERT_DRIVER_NOTE_SUCCESS',
    DELETE_DRIVER_NOTE = 'DELETE_DRIVER_NOTE',
    DELETE_DRIVER_NOTE_FAIL = 'DELETE_DRIVER_NOTE_FAIL',
    DELETE_DRIVER_NOTE_SUCCESS = 'DELETE_DRIVER_NOTE_SUCCESS',
    UPSERT_DRIVER_MESSAGE_FOR_COUNTER_PARTY = 'UPSERT_DRIVER_MESSAGE_FOR_COUNTER_PARTY',
    DELETE_DRIVER_MESSAGE_FOR_COUNTER_PARTY = 'DELETE_DRIVER_MESSAGE_FOR_COUNTER_PARTY',
    INIT_LOAD_ACTION = 'INIT_LOAD_ACTION',
    INIT_COMPLETE_TOUR_STOP_ACTIONS = 'INIT_COMPLETE_TOUR_STOP_ACTIONS',
}

export type TourActions = LoadDriverData | LoadDriverDataSuccess | LoadDriverDataFail |
    LoadTourSingle | LoadTourSingleSuccess | LoadTourSingleFail |
    CompleteTourStopActions | UnloadMachinesAtRaster | AddRequiredTrackedActions | AddRequiredTrackedActionsFail |
    FuelRefill | FuelRefillSuccess | FuelRefillFail |
    SearchMachine | SearchMachineSuccess | SearchMachineFail |
    SwitchMachine | SwitchMachineSuccess | SwitchMachineFail | CancelSwitchMachine | CancelSwitchMachineUpdating | UpdateRasterLocation |
    UpsertDriverNote | UpsertDriverNoteSuccess | UpsertDriverNoteFail |
    DeleteDriverNote | DeleteDriverNoteSuccess | DeleteDriverNoteFail |
    UpsertDriverMessageForCounterParty | DeleteDriverMessageForCounterParty |
    ToggleToursFilter;
